function GenomeExome() {
  return (
    <div className="flex flex-col gap-4">
      <li className="bullet-item">
        The allelic frequency in genomes and exomes according to <b>GNOMAD</b>, the &nbsp;
        <a className="tt" target="blank" href="http://gnomad.broadinstitute.org/">
          Genome Aggregation Database
        </a>
        . The data spans 125,748 exomes and 71,702 genomes from unrelated individuals sequenced as part of
        various disease-specific and population genetic studies (
        <a className="tt" target="blank" href="http://gnomad.broadinstitute.org/downloads">
          release 2.1.1
        </a>{' '}
        for exomes and 3.0 for genomes)
      </li>
    </div>
  );
}

export default GenomeExome;
